
import { Injectable, Injector } from '@angular/core';
import { Observable, Subject, timer, empty, of, throwError, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { PaymentRequestViewModel } from 'src/app/models/paymentRequestModel'
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService {

  constructor(public http: HttpClient, authService: AuthService) {
    super(authService);
  }

  getAllPaymentRequestList(partyId: string): Observable<PaymentRequestViewModel[]> {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get<PaymentRequestViewModel[]>(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //create transaction - add transaction payment link
  public createTransaction(transactionData: any) {
    //console.log('transdata', transactionData)
    return this.http.post(this.baseUrl + '/Transaction', transactionData,
      this.headerWithToken()).pipe(map(res => res));
  }

  //cancel payment
  public cancelPayment(transactionData: any) {
    return this.http.post(this.baseUrl + '/CancelRequest', transactionData,
      this.headerWithToken()).pipe(map(res => res));
  }

  //payment request Details
  public paymentReqDetails(paymentRequestId: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/PaymentRequests?paymentRequestId=' + paymentRequestId,
      this.headerWithToken()).pipe(map(res => res));
  }

  public paymentReqDetailsToken(paymentRequestId: any, token: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/PaymentRequests?paymentRequestId=' + paymentRequestId,
      this.headerWithTokenPayment(token)).pipe(map(res => res));
  }

  public paymentReqQstring(qs: any) {
    const headers = new HttpHeaders(
      {
        'Content-Type': 'application/xml',
      })
    var raw = '<string>' + qs + '</string>';
    // return this.http.post(this.baseUrl + '/PaymentRequests/paymentquerystring', raw, { headers: headers });
    return this.http.post<any>(this.baseUrl + '/PaymentRequests/paymentquerystring', raw,
      { headers: headers }).pipe(map(res => res));
  }

  //Add Payment transaction
  public addPaymentTransaction(transData: any, token: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/TransactionPayment', transData,
      this.headerWithTokenPayment(token)).pipe(map(res => res));
  }

  //confirm payment
  public confirmPayment(token: any, paymentId: any, cardNumber: any, cvv: any): Observable<any> {
    var raw = '<string>' + paymentId + "%7C" + cardNumber + "%7C" + cvv + '</string>';
    return this.http.post<any>(this.baseUrl + '/TransactionPayment/processtransaction', raw,
      this.headerWithTokenXml(token)).pipe(map(res => 
        res));
  }

  //All payment req
  public allPaymentReq(partyId: string) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //All open payment req
  public allOpenPaymentReq(partyId: string) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=open',
      this.headerWithToken()).pipe(map(res => res));
  }

  //All settled payment req
  public allSettlePaymentReq(partyId: string) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=settled',
      this.headerWithToken()).pipe(map(res => res));
  }

  //All failed payment req
  public allFailedPaymentReq(partyId: string) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=failed',
      this.headerWithToken()).pipe(map(res => res));
  }

  //All remit payment req
  public allRemitPaymentReq(partyId: string) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=Remitted',
      this.headerWithToken()).pipe(map(res => res));
  }

  //All Expired
  public allExpiredPaymentReq(partyId: any) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=Expired',
      this.headerWithToken()).pipe(map(res => res));
  }

  //All success
  public allSuccessPaymentReq(partyId: any) {
    partyId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/PaymentRequests/list?partyId=' + partyId + '&paymentStatus=settled',
      this.headerWithToken()).pipe(map(res => res));
  }

  //payment transaction
  //search by city
  public searchByCity(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/appraisal/city?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //search by zip
  public searchByZipCode(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/appraisal/zipcode?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //search by add
  public searchByAdd(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/appraisal/address?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //search Api payment transaction
  public search(from: any, to: any, paymentStatusId: any,
    customer: any,
    address: any,
    borrowerName: any, cardHolderName: any,
    ccNumberFirstFour: any,
    ccNumberLastFour: any,
    city: any,
    loanNumber: any,
    state: any,
    zip: any,
    vendorId: any,
    trackingNumber : any
   ) {
    return this.http.get(this.baseUrl + '/Payment/list?from=' + from + '&to=' + to + '&paymentStatusId=' + paymentStatusId + '&customer=' + customer
      + '&address=' + address + '&borrowerName=' + borrowerName + '&cardHolderName=' + cardHolderName +
      '&ccNumberFirstFour=' + ccNumberFirstFour + '&ccNumberLastFour=' + ccNumberLastFour + '&city=' + city + '&loanNumber=' + loanNumber + '&state=' 
      + state + '&zip=' + zip + '&vendorId=' + vendorId + '&trackingNumber='+trackingNumber ,
      this.headerWithToken()).pipe(map(res => res));
  }

  // ops payment all detail by id
  public PaymentDetailsByID(paymentID: any) {
    return this.http.get(this.baseUrl + '/paymentdetail/all/' + paymentID,
      this.headerWithToken()).pipe(map(res => res));
  }

  //search cardholdername
  public searchByCardName(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/cardholdernames?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //trackingNumber
  public searchByTrackingNum(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/trackingNumbers?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }


  //loan number
  public searchByLoan(from: any, to: any, hint: any, VendorRegistrationId: any, customer: any) {
    return this.http.get(this.baseUrl + '/Payment/loannumbers?from=' + from + '&to=' + to + '&hint=' + hint + '&VendorRegistrationId=' + VendorRegistrationId + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //search settlement
  public searchSettlementList(from: any, to: any, showRefund: any, customer: any) {
    return this.http.get(this.baseUrl + '/settlement/list?from=' + from + '&to=' + to + '&showRefund=' + showRefund + '&customer=' + customer,
      this.headerWithToken()).pipe(map(res => res));
  }

  //remittance 
  public searchRemittance(from: any, to: any, paymentStatusId: any, vendorIdForCustomer: any, customer: any,
    internalVendorId: any, lendor: any) {
    return this.http.get(this.baseUrl + '/remit/list?from=' + from + '&to=' + to + '&paymentStatusId=' + paymentStatusId + '&vendorIdForCustomer=' + vendorIdForCustomer +
      '&customer=' + customer + '&internalVendorId=' + internalVendorId + '&lendor=' + lendor,
      this.headerWithToken()).pipe(map(res => res));
  }

  //get remittance details
  public getRemittanceDetails(pageSize: any, skip: any, customerId: any, paymentRequestId: any) {
    return this.http.get(this.baseUrl + '/RemitReport/list?pageSize=' + pageSize + '&skip=' + skip + '&customerId=' + customerId + '&paymentRequestId=' + paymentRequestId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //
  private dataSubject = new BehaviorSubject<any>(null);
  public data$ = this.dataSubject.asObservable();

  sendData(data: any) {
    this.dataSubject.next(data);
  }

  //go back button payment trans
  private tableData: any[] = [];

  setTableData(data: any[]) {
    this.tableData = data;
  }

  getTableData() {
    return this.tableData;
  }

  clearCache() {
    this.tableData = null;
  }

  public getNewToken(oldtToken: any): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/Authorise/generatenewtoken',
      this.headerWithTokenPayment(oldtToken)).pipe(map(res => res));
  }

  // DOWNLOAD CSV TEMPLATE
public downloadTemplate(): Observable<Blob> {
  const headers = this.headerWithToken().headers;

  return this.http.get(this.baseUrl + '/Transaction/download-template', {
    headers: headers,
    responseType: 'blob' // CORRECT
  });
}


// UPLOAD BULK CSV

public uploadBulkTransactions(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('file', file);

  return this.http.post(
    this.baseUrl + '/Transaction/upload-bulk-transactions',
    formData,
    {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.authService.getToken()
      })
    }
  );
}


// public uploadBulkTransactions(file: File): Observable<any> {
//   const formData = new FormData();
//   formData.append('file', file);

//   return this.http.post(
//     this.baseUrl + '/Transaction/upload-bulk-transactions',
//     formData,
//     this.headerWithToken() // passes Authorization token
//   );
// }



}
